import FormattedCurrency from "./formatted-currency";
import pure from "./higher-order/pure";
import React from "react";
import { maximumTotalPrize, totalPrize } from "../payouts";

export default pure(function TournamentPrize({ tournament, tokenTypes }) {
  if (tournament.get("variable_prize")) {
    var currentPrize = totalPrize(tournament, tokenTypes);
    var maxPrize = maximumTotalPrize(tournament, tokenTypes);
    if (currentPrize < maxPrize) {
      return (
        <span>
          <FormattedCurrency dollarsValue={currentPrize} pointsValue={tournament.get("points_prize_pool")} />

          <span>
            {" "}
            -

            {" "}
          </span>

          <FormattedCurrency dollarsValue={maxPrize} pointsValue={tournament.get("points_prize_pool")} />
        </span>
      );
    }
  }
  return (
    <FormattedCurrency dollarsValue={totalPrize(tournament, tokenTypes)} pointsValue={tournament.get("points_prize_pool")} />
  );
});
